import axios from '@api'

export default {
    getDictionaryList(json) {
        return axios.post(`api/management/dictionary/list`, JSON.stringify(json));
      },
    getDictionaryListById(dictionaryid) {
        return axios.get(`api/management/dictionary/` + dictionaryid);
      }, 
    saveMasterDictionary(jsonDictionary) {
      return axios.post(`api/management/dictionary/save/`, jsonDictionary);
    },
    deleteMasterDictionary(jsonDictionary) {
      return axios.put('api/management/dictionary/delete', jsonDictionary)
    },
}